import axios from "axios";
import { store } from "../../../redux/store";
import { setLogout } from "../../../redux/slices/authSlice";
import { setLogoutUser } from "../../../redux/slices/userSlice";

const logoutAndRedirect = () => {
  try {
    store.dispatch(setLogout());
    store.dispatch(setLogoutUser());
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  } catch (err) {
    console.error("Error during forced logout", err);
  } finally {
    window.location.href = "/";
  }
};

async function callPiggybackAPI(path, query = {}, body = {}, requestType) {
  const payload = {
    path,
    query,
    body,
    requestType,
  };

  try {
    const api = localStorage.getItem("api");
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const response = await axios.post(`${api}/truink/piggyback`, payload, {
      headers,
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error calling piggyback API:", error.message);

      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);

        // If the token is expired/invalid, force logout so the user returns to login
        const status = error.response?.status;
        const data = error.response?.data;
        if (status === 401 || status === 403 || data === "jwt expired") {
          logoutAndRedirect();
        }

        const customError = new Error(error.response?.data || "API Error");
        customError.status = error.response?.status;
        customError.response = error.response;
        throw customError;
      }

      if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error message:", error.message);
      }
    } else {
      console.error("Error calling piggyback API:", error);
    }

    return null;
  }
}
export default callPiggybackAPI;
